import React from "react";
import { IconType } from "react-icons";
import { Link } from "react-router-dom";

type Props = {
  label: string;
  text: React.ReactNode;
  icon: IconType;
  highlight?: boolean;
  link?: string;
};

export const LoungeInfoItem: React.FC<Props> = ({ label, text, icon: Icon, highlight = false, link }) => {
  return (
    <div
      className={`group flex items-start space-x-4 p-4 rounded-xl transition-all duration-300 hover:shadow-md ${
        highlight ? "bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200" : "bg-gray-50 hover:bg-gray-100"
      }`}
    >
      <div
        className={`p-2 rounded-lg ${
          highlight ? "bg-blue-100" : "bg-white"
        } shadow-sm group-hover:shadow-md transition-shadow duration-300`}
      >
        {link ? (
          <Link to={link} className="no-underline cursor-pointer">
            <Icon className={`w-5 h-5 ${highlight ? "text-blue-600" : "text-gray-600"}`} />
          </Link>
        ) : (
          <Icon className={`w-5 h-5 ${highlight ? "text-blue-600" : "text-gray-600"}`} />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-900 mb-1">{label}</p>
        <div className="px-3 py-1.5 bg-white rounded-lg border border-gray-200 shadow-sm">
          <p className="text-sm text-gray-700 font-medium">{text}</p>
        </div>
      </div>
    </div>
  );
};
